import { DmaLocationData } from '@components/Dashboard/CampaignAnalytics/slice/schema';
import { buildChartOptions } from '@configurations/campaignAnalytics/dmaVisitsChart';
import { Grid, Stack } from '@mui/material';
import Highcharts from 'highcharts';
import HighchartsReact from 'highcharts-react-official';
import { useMemo } from 'react';
import { ChartCard } from '../ChartCard';
import { EditableChartProps } from './chartProps';
import LocationTable, { LocationTableProps } from '../LocationTable';

type DmaVisitsProps = EditableChartProps;

const DMA_COUNT = 20;

type TableColumn = keyof DmaLocationData | 'rank';

type ColumnData = {
  column: TableColumn;
  label: string;
};

const ORDERED_COLUMNS: ColumnData[] = [
  { column: 'rank', label: 'Rank' },
  { column: 'location', label: 'DMA' },
  { column: 'visitIndex', label: 'Visit Index' },
];

const buildTableData = (
  locationData: DmaLocationData[]
): LocationTableProps['tableData'] => [
  ORDERED_COLUMNS.map(columnData => ({
    key: columnData.column,
    value: columnData.label,
  })),
  ...locationData.map((dmaLocation, i) =>
    ORDERED_COLUMNS.map(columnData => ({
      key: columnData.column,
      value:
        columnData.column === 'rank' ? i + 1 : dmaLocation[columnData.column],
    }))
  ),
];

const DmaVisits = (props: DmaVisitsProps) => {
  const { report, ...chartCardProps } = props;

  const orderedDmaData = useMemo(
    () => report.dmaVisits.data.toSorted((a, b) => b.visitIndex - a.visitIndex),
    [report]
  );

  const memoizedChartOptions = useMemo(() => {
    return buildChartOptions(orderedDmaData);
  }, [orderedDmaData]);

  return (
    <ChartCard
      title="Top DMA Visits"
      description={`${props.campaignName} (${props.campaignId})`}
      report={report.dmaVisits}
      {...chartCardProps}
    >
      <Grid container>
        <Grid size={6}>
          <Stack height="100%" justifyContent="center">
            <HighchartsReact
              constructorType="mapChart"
              highcharts={Highcharts}
              options={memoizedChartOptions}
            />
          </Stack>
        </Grid>
        <Grid size={6}>
          <LocationTable
            tableData={buildTableData(orderedDmaData.slice(0, DMA_COUNT))}
          />
        </Grid>
      </Grid>
    </ChartCard>
  );
};

export default DmaVisits;
